import { Box, StyleSystemProps, styled } from '@withjoy/joykit';

export const StyledRoot = styled(Box)``;

const rootStyles: StyleSystemProps = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

export const styles = { root: rootStyles };
